// Minimum quantity validation for Mini variants - Product Page & Quick Add Modal
(function() {
  // All Mini variant IDs
  const MINI_VARIANT_IDS = [
    '56613660328313', // Original Classic Banana Bread (Mini)
    '56634509918585', // Toasted Nutty Bliss Banana Bread (Mini)
    '56634539770233', // Dreamy Nutella Banana Bread (Mini)
    '56634559463801', // Tropical Coconut Banana Bread (Mini)
    '56634607403385', // Crunchy Oreo Banana Bread (Mini)
    '56634621297017'  // Milk Choc Burst Banana Bread (Mini)
  ];
  
  const MIN_QUANTITY = 6;
  const WARNING_MESSAGE = 'Minimum of six selections required';

  // Add CSS for the warning message
  const style = document.createElement('style');
  style.textContent = `
    .mini-qty-warning {
      color: #3D081B;
      font-size: 0.875rem;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      display: block;
    }
    button.disabled-min-qty {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
    .disabled-min-qty-container {
      opacity: 0.5;
      pointer-events: none;
    }
  `;
  document.head.appendChild(style);

  function isMiniVariant(variantId) {
    return MINI_VARIANT_IDS.includes(variantId) || MINI_VARIANT_IDS.includes(String(variantId));
  }

  function updateButtonState(form) {
    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const submitBtn = form.querySelector('button[name="add"], button[type="submit"], .product-form__submit, .quick-add, [data-quick-add]');
    
    if (!variantInput || !submitBtn) return;
    
    // Skip forms without visible quantity inputs (like simple product cards)
    if (!qtyInput || qtyInput.offsetParent === null) return;
    
    const variantId = variantInput.value;
    const qty = parseInt(qtyInput.value) || 1;
    
    let warningMsg = form.querySelector('.mini-qty-warning');
    
    // Find PayPal and other payment buttons
    const paypalButton = form.querySelector('[data-paypal-button], .paypal-button, [class*="paypal"]');
    const dynamicCheckoutButtons = form.querySelector('.shopify-payment-button, [data-shopify-buttoncontainer]');
    
    // Check if this is a mini variant
    if (isMiniVariant(variantId)) {
      if (qty < MIN_QUANTITY) {
        // Disable add to cart button and show warning
        submitBtn.classList.add('disabled-min-qty');
        submitBtn.disabled = true;
        submitBtn.setAttribute('disabled', 'disabled');
        
        // Disable PayPal button
        if (paypalButton) {
          paypalButton.classList.add('disabled-min-qty');
          paypalButton.style.pointerEvents = 'none';
          paypalButton.style.opacity = '0.5';
        }
        
        // Disable dynamic checkout buttons (PayPal, Shop Pay, etc.)
        if (dynamicCheckoutButtons) {
          dynamicCheckoutButtons.classList.add('disabled-min-qty-container');
        }
        
        if (!warningMsg) {
          warningMsg = document.createElement('div');
          warningMsg.className = 'mini-qty-warning';
          warningMsg.textContent = WARNING_MESSAGE;
          
          // Insert after quantity input container
          const qtyContainer = qtyInput.closest('.quantity, .product-form__input, .quantity-selector, [class*="quantity"]');
          if (qtyContainer && qtyContainer.parentNode) {
            qtyContainer.parentNode.insertBefore(warningMsg, qtyContainer.nextSibling);
          } else {
            qtyInput.parentNode.insertBefore(warningMsg, qtyInput.nextSibling);
          }
        }
        warningMsg.style.display = 'block';
      } else {
        // Quantity is 6 or more - enable all buttons and hide warning
        submitBtn.classList.remove('disabled-min-qty');
        submitBtn.disabled = false;
        submitBtn.removeAttribute('disabled');
        
        // Enable PayPal button
        if (paypalButton) {
          paypalButton.classList.remove('disabled-min-qty');
          paypalButton.style.pointerEvents = '';
          paypalButton.style.opacity = '';
        }
        
        // Enable dynamic checkout buttons
        if (dynamicCheckoutButtons) {
          dynamicCheckoutButtons.classList.remove('disabled-min-qty-container');
        }
        
        if (warningMsg) {
          warningMsg.style.display = 'none';
        }
      }
    } else {
      // Not a mini variant - make sure all buttons are enabled
      submitBtn.classList.remove('disabled-min-qty');
      submitBtn.disabled = false;
      submitBtn.removeAttribute('disabled');
      
      // Enable PayPal button
      if (paypalButton) {
        paypalButton.classList.remove('disabled-min-qty');
        paypalButton.style.pointerEvents = '';
        paypalButton.style.opacity = '';
      }
      
      // Enable dynamic checkout buttons
      if (dynamicCheckoutButtons) {
        dynamicCheckoutButtons.classList.remove('disabled-min-qty-container');
      }
      
      if (warningMsg) {
        warningMsg.style.display = 'none';
      }
    }
  }

  function setupForm(form) {
    // Avoid setting up the same form multiple times
    if (form.dataset.miniValidationSetup) return;
    form.dataset.miniValidationSetup = 'true';
    
    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    
    if (!variantInput || !qtyInput) return;
    
    // Initial check
    setTimeout(function() {
      updateButtonState(form);
    }, 100);
    
    // Listen for quantity changes - multiple events
    qtyInput.addEventListener('input', function() {
      updateButtonState(form);
    });
    qtyInput.addEventListener('change', function() {
      updateButtonState(form);
    });
    qtyInput.addEventListener('keyup', function() {
      updateButtonState(form);
    });
    
    // Listen for clicks on +/- buttons if they exist
    const qtyButtons = form.querySelectorAll('button[name="plus"], button[name="minus"], .quantity__button, [class*="quantity"] button');
    qtyButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(function() {
          updateButtonState(form);
        }, 50);
      });
    });
    
    // Listen for variant changes (size selection)
    variantInput.addEventListener('change', function() {
      setTimeout(function() {
        updateButtonState(form);
      }, 50);
    });
    
    // Also listen for clicks on variant selector buttons/labels
    const variantSelectors = form.querySelectorAll('input[type="radio"], label[for*="option"], .variant-input');
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('click', function() {
        setTimeout(function() {
          updateButtonState(form);
        }, 100);
      });
      selector.addEventListener('change', function() {
        setTimeout(function() {
          updateButtonState(form);
        }, 100);
      });
    });
    
    // Watch for programmatic changes to variant input
    const variantObserver = new MutationObserver(function() {
      updateButtonState(form);
    });
    variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    
    // Watch for programmatic changes to quantity input value
    const qtyObserver = new MutationObserver(function() {
      updateButtonState(form);
    });
    qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
  }

  function init() {
    console.log('Mini variant validation loaded - Product pages & Quick add modals');
    
    // Setup all existing forms (product pages and any visible modals)
    function setupAllForms() {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
        setupForm(form);
      });
    }
    
    setupAllForms();
    
    // Watch for new forms being added (modals opening)
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.tagName === 'FORM' && node.action && node.action.includes('/cart/add')) {
              setupForm(node);
            }
            const forms = node.querySelectorAll ? node.querySelectorAll('form[action*="/cart/add"]') : [];
            forms.forEach(function(form) {
              setupForm(form);
            });
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    
    // Prevent form submission if minimum not met
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        const variantInput = form.querySelector('[name="id"]');
        const qtyInput = form.querySelector('[name="quantity"]');
        
        if (variantInput && qtyInput) {
          const variantId = variantInput.value;
          const qty = parseInt(qtyInput.value) || 1;
          
          if (isMiniVariant(variantId) && qty < MIN_QUANTITY) {
            e.preventDefault();
            e.stopPropagation();
            alert(WARNING_MESSAGE);
            return false;
          }
        }
      }
    }, true);
    
    // Intercept AJAX cart adds
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        const options = args[1] || {};
        if (options.body) {
          try {
            const data = JSON.parse(options.body);
            if (isMiniVariant(data.id)) {
              const qty = parseInt(data.quantity) || 1;
              if (qty < MIN_QUANTITY) {
                alert(WARNING_MESSAGE);
                return Promise.reject(new Error('Minimum quantity not met'));
              }
            }
          } catch (e) {
            // Continue
          }
        }
      }
      return originalFetch.apply(this, args);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();